function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, InputGroup, Label, Input } from 'reactstrap';
import Collector from "../../../../services/collector";
import { useWorkFlow } from "../../../contexts/workflow";
import useActionsTypes from "../../actions-types.hook";
import TranslateObj from "../../../common/translation-object";
import Loader from "../../../common/loader";
var Radio = function Radio(props) {
  var onChange = props.onChange,
    elements = props.elements,
    index = props.index,
    disableLoader = props.disableLoader;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentOrder = collector.currentOrder,
    responses = collector.responses,
    currentQuestion = collector.currentQuestion;
  var type = 'radio';
  var _useActionsTypes = useActionsTypes(),
    event = _useActionsTypes.event,
    loaded = _useActionsTypes.loaded;
  var _useState = useState(loaded),
    _useState2 = _slicedToArray(_useState, 2),
    featureLoaded = _useState2[0],
    setFeatureLoaded = _useState2[1];
  var name = "radio_".concat(Math.random());
  var handleOnChange = function handleOnChange() {
    onChange.apply(void 0, arguments);
    event.change.apply(event, arguments);
  };
  useEffect(function () {
    if (!loaded) {
      return;
    }
    var Radioresponses = Collector.getCurrentOrderResponses(currentOrder, responses);
    var radioResponse = {};
    if (Radioresponses && Radioresponses.responses) {
      var keys = Object.keys(Radioresponses.responses);
      if (keys.length > 0) {
        radioResponse[keys[0]] = Radioresponses.responses[keys[0]];
      }
    }

    // Dans le cas d'une erreur humaine ou info, on peut qu'une réponse radio.
    elements.forEach(function (response) {
      if (radioResponse[response.alias]) {
        onChange(response, true, type, index);
      }
    });
    setFeatureLoaded(true);
  }, [loaded]);
  if (disableLoader !== true && !featureLoaded) {
    return /*#__PURE__*/React.createElement(Loader, {
      isLoading: !featureLoaded
    });
  }
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, elements.map(function (response) {
    var currentResponse = Collector.getQuestionResponseByKey(currentOrder, responses, response.alias, null, currentQuestion);
    var checked = currentResponse || false;
    return /*#__PURE__*/React.createElement(InputGroup, {
      className: "CollectorQuestionResponseInputgroup d-flex justify-content-center",
      key: "radio_".concat(Math.random())
    }, /*#__PURE__*/React.createElement(Label, {
      className: "radio-hover ".concat(checked ? 'checked' : '')
    }, /*#__PURE__*/React.createElement(Input, {
      type: "radio",
      name: name,
      checked: checked,
      value: Boolean(response.value),
      onChange: function onChange(e) {
        return handleOnChange(response, !checked, type, index);
      }
    }), /*#__PURE__*/React.createElement(TranslateObj, {
      from: response.name
    })));
  })));
};
Radio.propTypes = {
  onChange: PropTypes.func.isRequired,
  elements: PropTypes.arrayOf(PropTypes.shape({})),
  index: PropTypes.number
};
Radio.defaultProps = {
  elements: [],
  index: null
};
export default Radio;